import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function oneLowercaseCharacterValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const regex = new RegExp('^(?=.*[a-z]).+$');
    const isValid = regex.test(control.value);
    return isValid ? null : { oneLowercaseCharacter: { value: control.value } };
  };
}
